module.exports = __webpack_public_path__ + "assets/media/day5.40a5b593.mp3";